export enum VisitorEnum {
  PATIENT = 'PATIENT',
  PRESCRIBER = 'PRESCRIBER',
  INSURANCE = 'INSURANCE',
}